// extracted by mini-css-extract-plugin
export default {"modelDetailContactButtonList":"c-f_eL","modelDetailContactButtonList__item":"c-f_eM","modelDetailContactButtonList__itemContent":"c-f_eN"};